import React, { useContext, useRef, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import { Container, Grid, IconButton, Paper, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import CloseIcon from '@mui/icons-material/Close'
import BackEndAPI from '../../Services/BackEndAPI'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import InputText from '../../DevComponents/InputText'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import ClsFormatacao from '../../Utils/ClsFormatacao'
import { RelatInterface } from '../../ImportBackend/Interfaces/RelatInterface'
import ClsExportDataTableCSV from '../../Utils/ClsExportDataTableCSV'

export default function RelatorioAmostras () {


  const contexto = ( useContext( ContextoGlobal ) as ContextoGlobalInterface )

  const { setMensagemState } = contexto

  const navigate = useNavigate()

  const clsApi = new BackEndAPI()

  const abortController: AbortController = new AbortController()

  const clsFormatos: ClsFormatacao = new ClsFormatacao()

  const [dados, setDados] = useState<Array<RelatInterface>>( [] )
  const [pesquisa, setPesquisa] = useState<{ numeroOS: string }>( { numeroOS: '' } )

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'numeroAmostra',
      cabecalho: 'Amostra',
      alinhamento: 'left'
    },
    {
      campo: 'empresa',
      cabecalho: 'Empresa',
      alinhamento: 'left'
    },
    {
      campo: 'proprietario',
      cabecalho: 'Proprietário',
      alinhamento: 'left'
    },
    {
      campo: 'propriedade',
      cabecalho: 'Propriedade',
      alinhamento: 'left'
    },
    {
      campo: 'tipoAnalise',
      cabecalho: 'Análise',
      alinhamento: 'left'
    },
    {
      campo: 'identificacao01',
      cabecalho: 'Identificação 01',
      alinhamento: 'left'
    },
    {
      campo: 'identificacao02',
      cabecalho: 'Identificação 02',
      alinhamento: 'left'
    },
    {
      campo: 'valor',
      cabecalho: 'Valor',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatos.currency( v )
    }
  ]

  const onClickPesquisa = ( numeroOS: string ) => {

    const query = `
      getRelatorioAmostras(nCodOSOmie: "${numeroOS}") {
        numeroAmostra
        tipoAnalise
        valor
        empresa
        proprietario
        propriedade
        identificacao01
        identificacao02
        cultura01
        cultura02
        numeroOS
        pgto
        cidade
        uf
        filial
        nCodOSOmie
        cCodIntOSOmie
        chaveGrupo
      }
    `

    return clsApi.query<Array<RelatInterface>>( query, 'getRelatorioAmostras', 'Pesquisando Ordens de Serviços...', contexto, abortController ).then( rsRelat => {

      setDados( rsRelat )

    } ).catch( ( e ) => {

      setMensagemState( {
        cb: null,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Consultar Ordens de Serviços Pendentes!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

      setDados( [] )

    } )

  }

  const onExportarCSV = () => {
    const clsExporta: ClsExportDataTableCSV = new ClsExportDataTableCSV()

    clsExporta.exportCSV(
      'Amostras OS ' + ( pesquisa.numeroOS ? `- ${pesquisa.numeroOS}` : '' ),
      dados,
      Cabecalho
    )
  }

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Amostras na OS
                <Typography variant="body2" gutterBottom>
                  Relação de Amostras Enviadas na OS
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate( '/' )} >
                <CloseIcon />
              </IconButton>
            </Grid>


            <Grid item xs={12}>

              <InputText
                dados={pesquisa}
                field='numeroOS'
                label='Pesquisar'
                setState={setPesquisa}
                iconeEnd="search"
                onClickIconeEnd={() => onClickPesquisa( pesquisa.numeroOS )}
                mapKeyPress={[{ key: 'Enter', onKey: ( () => { onClickPesquisa( pesquisa.numeroOS ) } ) }]}
              />

            </Grid>

            <Grid item xs={12} sx={{ mt: 2 }}>
              <DataTable
                cabecalho={Cabecalho}
                dados={dados}
              />
            </Grid>

            <Grid item xs={12} sx={{ textAlign: 'right', mt: 5 }}>
              <Button disabled={!dados.length} variant='contained' onClick={() => onExportarCSV()}>Exportar em CSV</Button>
            </Grid>

          </Grid>
        </Paper>
      </Container>

    </>
  )
}